import React from 'react';
import { useGetUser } from 'hooks';
import AGLOPreferences from './AGLOPreferences';
import SuperAdminPreferences from './SuperAdminPreferences';

const Preferences = () => {
  const { isSuperAdmin, isAGLO } = useGetUser();

  return (
    <>
      {isSuperAdmin && <SuperAdminPreferences />}

      {isAGLO && <AGLOPreferences />}
    </>
  );
};

export default Preferences;
